var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2006_248)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2006_248",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 0H0.5V19H18.5V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2006_248)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2006_248",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 19
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 0H0.5V19H18.5V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2006_248)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.39123 3.2906C6.45788 2.82517 6.60011 2.56847 6.80161 2.39576C7.13692 2.10835 7.86138 1.85039 9.49844 1.85039C11.1355 1.85039 11.86 2.10835 12.1953 2.39576C12.3971 2.56874 12.5394 2.82598 12.606 3.2928C11.6998 3.18983 10.6671 3.15039 9.49844 3.15039C8.32844 3.15039 7.29619 3.18996 6.39123 3.2906ZM4.65732 3.60357C4.70126 2.67804 4.92514 1.76513 5.69526 1.10502C6.52662 0.392434 7.80216 0.150391 9.49844 0.150391C11.1947 0.150391 12.4703 0.392434 13.3016 1.10502C14.0747 1.76769 14.2973 2.68512 14.3401 3.61434C15.2257 3.86132 15.976 4.23459 16.5789 4.79809C17.7598 5.90197 18.1863 7.55983 18.3076 9.73933C18.3341 9.82158 18.3484 9.90931 18.3484 10.0004C18.3484 10.1581 18.3453 10.3172 18.3371 10.477C18.345 10.7797 18.3484 11.0914 18.3484 11.4122C18.3484 13.847 18.0305 15.845 16.5647 17.1545C15.1377 18.4294 12.8358 18.8504 9.49844 18.8504C7.81362 18.8504 6.41445 18.7683 5.26968 18.54C4.12066 18.3109 3.16866 17.923 2.43311 17.268C0.953691 15.9503 0.648438 13.8226 0.648438 11.0004C0.648438 10.7802 0.650292 10.5643 0.654421 10.3526C0.650174 10.2346 0.648438 10.1171 0.648438 10.0004C0.648438 9.93347 0.656167 9.86836 0.670788 9.8059C0.762976 7.57253 1.17027 5.85754 2.43311 4.73283C3.03372 4.19791 3.77865 3.84121 4.65732 3.60357ZM2.35543 10.3414C2.40937 7.91962 2.77812 6.70204 3.56376 6.00233C3.99488 5.61836 4.62622 5.32257 5.60219 5.12792C6.58243 4.93241 7.84992 4.85039 9.49844 4.85039C11.1477 4.85039 12.4126 4.93255 13.3898 5.13337C14.3607 5.33289 14.9877 5.63775 15.418 6.04001C16.1901 6.76175 16.5631 8.01557 16.6353 10.4594C16.6121 10.8257 16.557 11.1217 16.4597 11.3699C16.3354 11.6871 16.1266 11.9662 15.7246 12.2156C14.8419 12.7634 13.0676 13.1504 9.50448 13.1504C5.94167 13.1504 4.16367 12.7635 3.27739 12.2151C2.87347 11.9651 2.66345 11.6855 2.5384 11.3683C2.43039 11.0944 2.37395 10.7621 2.35543 10.3414ZM16.4811 13.7434C16.2998 14.7427 15.9632 15.4123 15.4321 15.8867C14.5258 16.6964 12.8277 17.1504 9.49844 17.1504C7.84992 17.1504 6.58243 17.0684 5.60219 16.8729C4.62622 16.6782 3.99488 16.3824 3.56376 15.9985C3.04614 15.5374 2.70949 14.8516 2.52461 13.7448C3.87415 14.512 6.06684 14.8504 9.50448 14.8504C12.9432 14.8504 15.1341 14.5118 16.4811 13.7434ZM6.64844 11.0004C6.64844 10.5309 7.029 10.1504 7.49844 10.1504H11.4984C11.9679 10.1504 12.3484 10.5309 12.3484 11.0004C12.3484 11.4698 11.9679 11.8504 11.4984 11.8504H7.49844C7.029 11.8504 6.64844 11.4698 6.64844 11.0004Z",
    fill: "#185A7D"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2006_248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 19,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.60df00a05027028b9bff9a29ce4fee3d.svg";
export { ForwardRef as ReactComponent };